import PrivatePagesWrapper from "components/PrivatePagesWrapper/PrivatePagesWrapper"
import useToast from "hooks/useToast"
import { AccessToApp, IncompletePersonalData, PPaymentMethods, UiModal } from "libs/raas-ui-react-components/src/components"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { defaultCard, deleteCard, getPaymentMethods, setNavigate } from "services/api/redsys.service"
import { PersonalDataModalLiterals } from "../TripSelector/TripSelector.util"
import { checkBillingAddress, getDeleteCardErrorLiterals, getDeleteCardLiterals, getGoogleApple, getPaymentCards, getPaymentsLiterals, getRandomCard, mapPaymentCards, typePay } from "./PaymentMethods.util"
import { getUserDetail } from "services/user/user.session.service"
import { getPaymentMethodsUser, setPaymentMethodsLocal } from "services/user/user.local.service"


export const PaymentMethodsFlow = () => {
  const [t] = useTranslation('paymentMethodsFlow');
  const [t2] = useTranslation("tripSelector");
  const navigate = useNavigate()
  const [cards, setCards] = useState(getGoogleApple(t,getPaymentMethodsUser()?.id) as any);
  const [cardToDelete, setCardToDelete] = useState({} as any);
  const [showDeleteCard, setShowDeleteCard] = useState(false);
  const [showDeleteCardError, setShowDeleteCardError] = useState(false);
  const [shownPersonalDataModal, setShownPersonalDataModal] = useState(false);
  const { openToast } = useToast();

  useEffect(() => {
    getPaymentMethods().then((response: any) => {
      //setCards(mapPaymentCards(response,t,false,getPaymentMethodsUser()?.id))  
      setCards(mapPaymentCards(response,t,false,undefined))  
    })
  }, [])

  const handleAddCard = (ev: CustomEvent) => {
    if(checkBillingAddress()==true){
      setNavigate('/app/payment-methods');
      navigate("/redsys:addCard");
    }else{
      setShownPersonalDataModal(true)
    }
  }

  const handleDeleteCheck = (ev: CustomEvent) => {
    setCardToDelete(ev.detail);
    setShowDeleteCard(true);
  }

  const handleSaveCard = (ev: CustomEvent) => {
    const id = ev?.detail?.id;
    const body = {
      "defaultPaymentMethod": "true"
    };
    if(id===typePay.GOOGLE || id===typePay.APPLE || id===typePay.XPAY ){
      let valueUserDetail = getUserDetail().email;
      
        setPaymentMethodsLocal({
          id:id,
          email:valueUserDetail
        })
        navigate("/personal-data");
    }else{
      defaultCard(id, body).then((response: any) => {
      }).catch((error: any) => {
        openToast("error", t("literals.title"), t("literals.errorSaving"));
      })
    }
  
  }

  const handleDeleteCard = () => {
    deleteCard(cardToDelete.id)
        .then(() => {
            const cardDeleted = cards.find(
                (el: any) => el.id === cardToDelete?.id,
            );
            const isDeleteCardSelected =
                cardDeleted && cardDeleted.selected;
            let aux = cards.filter((el: any) => el.id != cardToDelete?.id);
            if (
                isDeleteCardSelected &&
                aux.find((o: any) => new Date(o.expireDate) > new Date())
            ) {
                aux.find(
                    (o: any) => new Date(o.expireDate) > new Date(),
                ).selected = true;
            }
            setCards(aux);
            setShowDeleteCard(false);
        })
        .catch((error: any) => {
            setShowDeleteCardError(true);
        });
};

  const handleCloseModal = (ev: CustomEvent) => {
    setShowDeleteCard(false);
  }
  const handleCloseModalError = (ev: CustomEvent) => {
    setShowDeleteCardError(false);
  }

  const goToProfile = () => {
    navigate("/personal-data?goTo=/payment-methods");
  };

  return (
    <>
      <PPaymentMethods
        literals={JSON.stringify(getPaymentsLiterals(t))}
        cards={cards}
        onPPaymentMethodsAdd={handleAddCard}
        onPPaymentMethodsDelete={handleDeleteCheck}
        onPPaymentMethodSave={handleSaveCard}
      ></PPaymentMethods>
      {/* Footer */}
      <PrivatePagesWrapper></PrivatePagesWrapper>
      {/* Modals */}
      {/* Confirm delete */}
      <UiModal open={showDeleteCard} blockOverlay={true}>
        <AccessToApp
          literals={JSON.stringify(getDeleteCardLiterals(t))}
          onCancelModal={handleCloseModal}
          onOkModal={handleDeleteCard} />
      </UiModal>
      {/* Error deleting */}
      <UiModal open={showDeleteCardError} blockOverlay={true}>
        <AccessToApp
          literals={JSON.stringify(getDeleteCardErrorLiterals(t))}
          onCancelModal={handleCloseModalError}
          onOkModal={handleDeleteCard} />
      </UiModal>

      <UiModal open={shownPersonalDataModal} blockOverlay={true} onModalClosed={() => setShownPersonalDataModal(false)} notUseShiftLogic={true}>
      <IncompletePersonalData
            literals={JSON.stringify(PersonalDataModalLiterals(t2))}
            onCancelClickEvent={() => setShownPersonalDataModal(false)}
            onGoToProfileClickEvent={() => goToProfile()}
          />
      </UiModal>
    </>
  )
}

